import { HtmlTagFactory } from './HtmlTagFactory/HtmlTagFactory';

export default {
  Label: HtmlTagFactory('label'),
  Canvas: HtmlTagFactory('canvas'),
  Iframe: HtmlTagFactory('iframe'),
};
